import styled from 'styled-components'

export const StyledPageBusWrapper = styled.div`
  text-align: center;
  overflow: hidden;
  img {
    margin: 0 auto;
  }
`